import React, { createContext, useState, useContext, PropsWithChildren } from 'react';

interface ErrorContextType {
  error: string | null;
  status?: number | null;
  has403Error: boolean;
  setError: (error: string | null, status?: number | null) => void;
  clearError: () => void;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [error, setErrorState] = useState<string | null>(null);
  const [status, setStatus] = useState<number | null>(null);
  const [has403Error, setHas403Error] = useState(false);

  const setError = (error: string | null, status?: number | null) => {
    setErrorState(error);
    setStatus(status || null);
    if (status === 403) {
      setHas403Error(true);
    }
  };

  const clearError = () => {
    setErrorState(null);
    setStatus(null);
    setHas403Error(false);
  };

  return (
    <ErrorContext.Provider value={{ error, status, has403Error, setError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};
